import React from "react";
import configs from "../../../contentConfig";
import { formatFullDate } from "../../../utils/commanFunctions";

const FIELD_RENDERERS = {
  "opening-status-with-distance": (data, { opningStatus, distance }) => {
    const hasStatus = !!opningStatus;
    const hasVenue = !!data.venue_name;
    const hasDistance = distance && distance !== "0 mi";
    if (!hasStatus && !hasVenue && !hasDistance) return null;
    return (
      <p
        key="opening-status-with-distance"
        className="relative w-fit font-secondary font-normal text-transparent text-sm tracking-[0] leading-5"
      >
        {hasStatus && (
          <>
            {opningStatus.toLowerCase() === "closed" ? (
              <span className="text-[#888888]">Closed</span>
            ) : (
              <>
                <span className="text-[#888888]">Open </span>
                <span className="text-[#333333]">{opningStatus}</span>
              </>
            )}
            <span className="text-[#888888]"> - </span>
          </>
        )}
        {hasVenue ? (
          <span className="text-[#4D4D4D] leading-5 distance-value">
            {data.venue_name}
          </span>
        ) : (
          hasDistance && (
            <>
              <span className="text-[#333333] distance-value">{distance}</span>
              <span className="text-[#888888] distance-text"> from hotel</span>
            </>
          )
        )}
      </p>
    );
  },

  "opening-status": (_data, { opningStatus }) => {
    if (!opningStatus) return null;
    return (
      <p
        key="opening-status"
        className="relative w-fit font-secondary text-sm leading-5"
      >
        {opningStatus.toLowerCase() === "closed" ? (
          <span className="text-[#888888]">Closed</span>
        ) : (
          <>
            <span className="text-[#888888]">Open </span>
            <span className="text-[#333333]">{opningStatus}</span>
          </>
        )}
      </p>
    );
  },

  distance: (_data, { distance }) => {
    if (!distance || distance === "0 mi") return null;
    return (
      <p
        key="distance"
        className="relative w-fit font-secondary text-sm leading-5"
      >
        <span className="text-[#333333] distance-value">{distance}</span>
        <span className="text-[#888888] distance-text"> from hotel</span>
      </p>
    );
  },

  "venue-name": (data) => {
    if (!data.venue_name) return null;
    return (
      <p
        key="venue-name"
        className="relative w-fit font-secondary text-sm leading-5 text-[#4D4D4D]"
      >
        {data.venue_name}
      </p>
    );
  },

  rating: (data) => {
    if (!data.rating) return null;
    return (
      <div
        key="rating"
        className="flex items-center gap-1 small-cards-rating text-sm text-[#4D4D4D] font-secondary"
      >
        <svg
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.68323 2.30878C7.71245 2.24975 7.75758 2.20007 7.81353 2.16533C7.86949 2.13059 7.93404 2.11218 7.9999 2.11218C8.06576 2.11218 8.13031 2.13059 8.18626 2.16533C8.24222 2.20007 8.28735 2.24975 8.31656 2.30878L9.85656 5.42811C9.95802 5.63342 10.1078 5.81105 10.293 5.94575C10.4782 6.08044 10.6933 6.16819 10.9199 6.20145L14.3639 6.70545C14.4292 6.7149 14.4905 6.74243 14.5409 6.78491C14.5913 6.8274 14.6289 6.88314 14.6492 6.94585C14.6696 7.00855 14.6721 7.07572 14.6563 7.13974C14.6405 7.20376 14.6071 7.26208 14.5599 7.30811L12.0692 9.73345C11.905 9.89351 11.7821 10.0911 11.7111 10.3092C11.6402 10.5273 11.6233 10.7594 11.6619 10.9854L12.2499 14.4121C12.2614 14.4773 12.2544 14.5445 12.2296 14.6059C12.2048 14.6673 12.1632 14.7205 12.1096 14.7594C12.056 14.7984 11.9926 14.8214 11.9265 14.826C11.8604 14.8306 11.7944 14.8166 11.7359 14.7854L8.65723 13.1668C8.45438 13.0603 8.22868 13.0046 7.99956 13.0046C7.77044 13.0046 7.54475 13.0603 7.3419 13.1668L4.2639 14.7854C4.20545 14.8164 4.1395 14.8303 4.07353 14.8256C4.00757 14.8209 3.94424 14.7978 3.89076 14.7589C3.83728 14.72 3.79579 14.6669 3.771 14.6056C3.74622 14.5443 3.73914 14.4772 3.75056 14.4121L4.3379 10.9861C4.3767 10.7599 4.35989 10.5277 4.28892 10.3095C4.21796 10.0912 4.09497 9.89355 3.93056 9.73345L1.4399 7.30878C1.39229 7.2628 1.35856 7.20438 1.34254 7.14016C1.32652 7.07595 1.32886 7.00852 1.34928 6.94557C1.36971 6.88262 1.40741 6.82667 1.45808 6.7841C1.50876 6.74153 1.57037 6.71404 1.6359 6.70478L5.07923 6.20145C5.30607 6.16844 5.52149 6.08082 5.70695 5.9461C5.89242 5.81139 6.04237 5.63363 6.1439 5.42811L7.68323 2.30878Z"
            fill="#E8A127"
          />
        </svg>
        <span className="font-primary leading-5 text-[14px]">
          {data.rating}
        </span>
      </div>
    );
  },

  price_level: (data) => {
    if (!data.price_level) return null;
    return (
      <span
        key="price_level"
        className="flex font-primary items-center text-sm text-[#4D4D4D]"
      >
        {data.price_level}
      </span>
    );
  },

  start_time: (data) => {
    if (!data.start_time) return null;
    return (
      <div
        key="start_time"
        className="inline-flex items-center gap-0.5 relative flex-[0_0_auto]"
      >
        <p className="relative w-fit font-secondary font-medium text-[#333333] text-sm tracking-[-0.32px] leading-[normal]">
          {formatFullDate(data.start_time)}
        </p>
      </div>
    );
  },
};

const DEFAULT_DISPLAY = ["opening-status-with-distance", "rating"];

const DefaultSubComponet = ({ data, opningStatus, distance, groupData }) => {
  const groupName = groupData?.name;
  const display =
    configs?.explore?.cardDimension?.[groupName]?.display || DEFAULT_DISPLAY;
  const ctx = { opningStatus, distance };

  return (
    <>
      {display.map((key) => FIELD_RENDERERS[key]?.(data, ctx) || null)}
    </>
  );
};

export default DefaultSubComponet;
